import { useUserPermissions } from "@";

export function useCanShow(el, redirect = false) {
  const { permissions } = useUserPermissions();
  const hasPermission = permissions?.[el] || false;

  if (redirect && !hasPermission) {
    const targetPath =
      window.location.pathname === "/" ? "/profile" : "/not-have-permissions";
    window.location.replace(targetPath);
    return false;
  }

  return hasPermission;
}
